@use './variables' as *;

:host {
  display: $dropdown-base-host-display;
}

.content {
  position: fixed;
  width: $dropdown-base-width;
  min-width: $dropdown-base-min-width;
  max-width: $dropdown-base-max-width;
  height: $dropdown-base-height;
  min-height: $dropdown-base-min-height;
  max-height: $dropdown-base-max-height;
  margin-top: $dropdown-base-margin-top;
  margin-right: $dropdown-base-margin-right;
  margin-bottom: $dropdown-base-margin-bottom;
  margin-left: $dropdown-base-margin-left;
  padding-top: $dropdown-base-padding-top;
  padding-right: $dropdown-base-padding-right;
  padding-bottom: $dropdown-base-padding-bottom;
  padding-left: $dropdown-base-padding-left;
  background: $dropdown-base-background;
  box-shadow: $dropdown-base-box-shadow;
  border: $dropdown-base-border;
  border-radius: $dropdown-base-border-radius;
  overflow: $dropdown-base-overflow;
  z-index: $dropdown-base-z-index;
  box-sizing: $dropdown-base-box-sizing;

  &.top {
    margin-top: $dropdown-content-position-top-margin-top;
  }

  &.bottom {
    margin-top: $dropdown-content-position-bottom-margin-top;
  }
}
